import React from 'react';

import { getCookie } from 'cookies-next/client';

import { Table } from '@/components/AdminToolbox/components/Table';
import { ACCESS_TOKEN_KEY } from '@/constants/cookies.ts';
import { type User } from '@/modules/user/aliases';

type Props = {
  user: User;
  hasBulkListingAccess?: boolean;
  hasBoostedListingsAccess?: boolean;
};

export function UserInfo({
  user,
  hasBulkListingAccess,
  hasBoostedListingsAccess,
}: Props) {
  return (
    <Table
      rows={{
        'Access Token': getCookie(ACCESS_TOKEN_KEY),
        Id: user.id,
        Username: user.username,
        Email: user.email,
        Verified: user.verified ? 'true' : 'false',
        Country: user.country,
        'Has Boosted Listings Access': hasBoostedListingsAccess
          ? 'true'
          : 'false',
        'Has Bulk Listing': hasBulkListingAccess ? 'true' : 'false',
      }}
    />
  );
}
